<template lang="pug">

div.container-os
  template()
    el-steps.mt-20.mb-40(:active='indexTela', finish-status='success', align-center)
      el-step(
        v-if="numero && edicao",
        title='Adicionar/Remover processos',
        icon="el-icon-edit-outline"
      )
      el-step(
        v-else
        title='Adicionar processos',
        icon="el-icon-edit-outline"
      )
      el-step(
        title='Dados da ordem de serviço'
        icon="el-icon-tickets"
      )
      el-step(
        title='Função por equipe'
        icon="el-icon-tickets"
      )
  div#scroll
    div
      component(
      ref="passoCadastro"
      :is="this.telas[indexTela].componente"
      :usuario="usuario",
      :numero="numero",
      :edicao="edicao && primeiroPasso"
      @setOrdemServico="setOrdemServico"
      :ordemServico="ordemServico"
      :analistas="analistas"
      :analistasSelecionados="analistasSelecionados"
      :buscar="buscar")
    app-button(
      :isEtapaSalva="false"
      :showButtonCancelar="primeiroPasso"
      :showButtonProximo="!ultimoPasso"
      @proximo="proximo"
      @voltar="anterior"
      @cancelar="cancelar"
      @finalizar="finalizar"
      :isPrimeiroPasso="primeiroPasso"
      :isUltimoPasso="ultimoPasso"
    )
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import AppButton from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import DadosOrdemServico from './DadosOrdemServico'
import CaixaProcessoOs from '../listagem/CaixaProcessoOs'
import DadosEquipe from './DadosEquipe'
import ListagemProcessoOrdemServico from '../listagem/ListagemProcessoOrdemServico'
import _ from 'lodash'

export default {
  components: {
    AppButton,
    DadosOrdemServico,
    DadosEquipe,
    CaixaProcessoOs
  },

  mixins: [AppNotificacao],

  props: {
    numero: {
      required: false
    },
    edicao: {
      required: false
    }
  },

  data () {
    return {
      telas: [
        this.edicao
          ? { nome: 'EDITAR_OS', componente: ListagemProcessoOrdemServico }
          : { nome: 'CAIXA_PROCESSO_OS', componente: CaixaProcessoOs },
        { nome: 'DADOS_ORDEM_SERVICO', componente: DadosOrdemServico },
        { nome: 'DADOS_EQUIPE', componente: DadosEquipe }
      ],
      indexTela: 0,
      numeroExistente: false,
      ordemServico: {
        id: '',
        numero: null,
        documento: null,
        processos: [],
        analistas: [],
        responsaveis: [],
        municipio: {
          id: null
        }
      },
      analistas: [],
      fimCadastro: false
    }
  },

  created () {
    this.buscar()
  },

  beforeDestroy () {
    this.ordemServicoClear()
  },

  beforeRouteLeave (to, from, next) {
    if (!this.fimCadastro) {
      setTimeout(() => {
        this.confirmBox(
          this.$messages.CANCELAR_ANALISE_DEFAULT,
          this.$messages.TITULO_WARNING,
          () => {
            next()
          },
          () => {}
        )
      }, 200)
    } else {
      next()
    }
  },

  computed: {
    ...mapState({
      processos: state => state.ordemServico.processos
    }),
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    primeiroPasso () {
      return this.indexTela === 0
    },
    ultimoPasso () {
      return this.indexTela === this.telas.length - 1
    },
    analistasSelecionados () {
      return this.analistas.filter(a => a.selecionado)
    }
  },
  methods: {
    ...mapActions({
      ordemServicoClear: 'ordemServico/clear',
      getOrdemServicoPorNumero: 'ordemServico/getOrdemServicoPorNumero',
      getAnalistas: 'ordemServico/getAnalistas',
      getAnalistasTEQ: 'ordemServico/getAnalistasTEQ',
      salvarOrdemServico: 'ordemServico/salvar'
    }),

    async buscar () {
      if (this.usuario.perfilSelecionado.setor.codigo === 'GCQ') {
        this.analistas = await this.getAnalistasTEQ()
      } else {
        this.analistas = await this.getAnalistas()
      }

      if (this.numero) {
        const ordemServico = await this.getOrdemServicoPorNumero(this.numero)
        if (!ordemServico?.municipio?.id) {
          ordemServico.municipio = {
            id: undefined
          }
        }
        this.ordemServico = ordemServico
      }
      this.setAnalistasSelecionados()
      this.load = false
    },

    setAnalistasSelecionados () {
      this.analistas = _.map(this.analistas, analista => {
        // eslint-disable-line
        const analistaOrdemServico = this.ordemServico.processos.find(
          processo => processo.usuario.id === analista.id
        )
        const responsavelOrdemServico = this.ordemServico.responsaveis.find(
          responsavel => responsavel.responsavel.id === analista.id
        )
        if (analistaOrdemServico || responsavelOrdemServico) {
          analista.selecionado = true
          if (
            this.ordemServico.processos.find(
              p =>
                p.status &&
                p.status.codigo === 'FINALIZADO' && p.usuario.id === analista.id
            )
          ) {
            analista.disabled = true
          }
        }
        return analista
      })
    },

    async proximo () {
      if (
        this.indexTela > 0 &&
        (!(await this.$refs.passoCadastro.checkValidacao()) || this.ultimoPasso)
      ) {
        return
      }
      this.scrollTop()
      this.indexTela++
    },

    setOrdemServico (ordemServico) {
      this.ordemServico = ordemServico
    },

    anterior () {
      if (this.primeiroPasso) {
        this.$router.back()
        return
      }
      this.scrollTop()
      this.indexTela--
    },

    scrollTop () {
      document.getElementById('scroll').scrollIntoView({
        block: 'start'
      })
    },

    cancelar () {
      this.$router.go(-1)
    },

    async finalizar () {
      if (!(await this.$refs.passoCadastro.checkValidacao())) {
        return
      }

      this.ordemServico.responsaveis = this.analistasSelecionados.map(
        responsavel => {
          return { responsavel }
        }
      )

      if (this.ordemServico?.processos?.length > 0) {
        this.ordemServico.processos.map(processo => {
          processo.dataVencimento = null
          processo.dataAtualizacao = null
        })
      }

      if (this.ordemServico) {
        if (this.ordemServico.processos) {
          this.ordemServico.processos = this.ordemServico.processos.filter(
            p => p.usuario.id !== '' && p.usuario.id !== null
          )
        }
        await this.salvarOrdemServico(this.ordemServico)
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.ordemServico.id
            ? this.$messages.SUCESSO_EDITAR_OS
            : this.$messages.SUCESSO_CRIAR_OS
        )
      }
      this.fimCadastro = true
      this.$router.push({
        name: 'ORDEM_SERVICO'
      })
    }
  }
}
</script>
<style scoped>
.container-os {
  min-height: 89vh;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/ordemServico/OrdemServico.vue